module.exports = __webpack_public_path__ + "static/img/n-depth.555c7c5c.png";